import React from "react";
import "./index.css";

const GOIButton = ({ editMode, handleSaveBtnClick, disable }) => {
  const className = `goi-button ${!editMode ? "finalized" : "saved"}`;
  const buttonContent = !editMode ? "Finalize" : "Save";

  const handleOnClick = () => {
    if (buttonContent === "Save") {
      handleSaveBtnClick();
    }
  };

  return (
    <button
      onClick={handleOnClick}
      className={className}
      disabled={buttonContent === "Save" && disable}
    >
      {buttonContent}
    </button>
  );
};

export default GOIButton;
